import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import '@pocketbuy/outdoor-design-system/styles.css';
import './styles.css';
import { OperationsApp } from './routes/OperationsApp';
import {useSession} from './session';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 } } });
useSession.subscribe((state, previous) => {
  const accountChanged = state.session?.accessToken !== previous.session?.accessToken;
  if (accountChanged || state.session?.activeRole !== previous.session?.activeRole) {
    for (const key of ['performance','performance-period','performance-scroll']) {
      if (!accountChanged && key !== 'performance') continue;
      void queryClient.cancelQueries({queryKey:[key]});
      queryClient.removeQueries({queryKey:[key]});
    }
  }
});
// A newly activated service worker controls the current page only after reload.
// Reload once on that event so operational users do not need to clear browser cache.
let reloadedForServiceWorker = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadedForServiceWorker) return;
    reloadedForServiceWorker = true;
    window.location.reload();
  });
}
const updateServiceWorker = registerSW({
  immediate: true,
  onNeedRefresh() { void updateServiceWorker(true); },
  onRegisteredSW(_serviceWorkerUrl: string, registration: ServiceWorkerRegistration | undefined) {
    if (registration) window.setInterval(() => { void registration.update(); }, 60_000);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><QueryClientProvider client={queryClient}><BrowserRouter><OperationsApp /></BrowserRouter></QueryClientProvider></React.StrictMode>,
);
